import { Button, Flex, Text } from '@chakra-ui/react';
// @ts-ignore
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SidebarWithHeader from '../../components/sidebar/sidebar';
// @ts-ignore
import styles from '../../assets/css/modular/admin.module.css';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import FormikControl from '../../components/form-components/FormikControl';
import axios from 'axios';
import ToastMessage from '../../components/utility/ToastMessage';

export default function EditAdmin(){
    return <EditAdminForm />;
}

const EditAdminForm = () =>{
    // @ts-ignore
    const navigate = useNavigate();
    const user_id = useParams().user_id;
    const [admin, setAdmin] = useState({});

    const token = localStorage.getItem('my_token');

    let config = {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
    };

    useEffect(() => {
        fetchAdmin();
    },[]);

    const fetchAdmin = async () => {
        try {
            var apiResponse = (await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/${user_id}`,{
                headers: config
            })).data;
            if (apiResponse.error === false && apiResponse.results) {
                setAdmin(apiResponse.results);
            }
        } catch (error) {
            console.log({ error });
        }
    }

    const validataionSchema = Yup.object({
        email: Yup.string().email("Invalid Email Address").required("Required"),
        mobile: Yup.string().matches(/^\d+$/, 'Please enter digits only').max(11, 'Mobile no must be at least 11 characters').required("Required"),
        user_type: Yup.string().required("Required"),
        fullname: Yup.string().required("Required"),
        dob: Yup.string().required("Required"),
    });

    const onSubmit = (values) => {
        let config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
              }
        };

        axios
        .patch(`${process.env.REACT_APP_API_URL}/api/admin/${user_id}`, values, config)
        .then((response) => {
            ToastMessage('success','Successfully updated');
            navigate('/admins');
        })
        .catch((error) => {
            ToastMessage('error','Something went wrong');
        });
    };

    const user_type_options = [
        {key: 1, value: "Super Admin"},
        {key: 2, value: "Admin"}
    ];

    function checkEmpty(param){
        for(let i in param){
            return false;
        }
        return true;
    }

    return (
        <>
            <Flex justifyContent={'center'} className="admin_title">
                <Text fontSize="xl">EDIT ADMIN</Text>
            </Flex>
            {checkEmpty(admin) === false &&
                <div className={styles.apply_form}>
                    <Formik
                        initialValues={admin}
                        validationSchema={validataionSchema}
                        onSubmit={onSubmit}
                    >
                        {
                            formik => (
                                <Form>
                                    <FormikControl required={true} control='input' type='email' label='Email' name='email' />
                                    <FormikControl required={true} control='input' type='text' label='Mobile No' name='mobile' />
                                    <FormikControl required={true} control='radio' label='Admin Type' name='user_type' options={user_type_options} />
                                    <FormikControl required={true} control='input' type='text' label='Fullname' name='fullname' />
                                    <FormikControl required={true} control='date' type='date' label='Date of Birth' name='dob' />

                                    <div>
                                        <Button colorScheme="green" type="submit">Update</Button>
                                    </div>
                                </Form>
                            )
                        }
                    </Formik>
                </div>
            }
        </>
    )
}
